import React, { useState, useRef } from 'react'

import Icon from '../icon'

import { Container, Input } from './styles'

import IProps from './props'

const SearchInput = ({ onSearch, ...inputProps }: IProps) => {
  const [isFocused, setIsFocused] = useState(false)

  const inputRef = useRef<HTMLInputElement>(null)

  const handleFocus = () => {
    setIsFocused(true)
  }

  const handleBlur = () => {
    setIsFocused(false)
  }

  return (
    <Container className={isFocused ? 'focused' : ''}>
      <Icon name="search" onClick={onSearch} />
      <Input
        ref={inputRef}
        onFocus={handleFocus}
        onBlur={handleBlur}
        name="search"
        {...inputProps}
      />
    </Container>
  )
}

export default SearchInput
